import React, { forwardRef } from "react";

const Select = forwardRef(
  ({ label, error, helperText, children, className = "", required = false, ...props }, ref) => {
    return (
      <div className="flex flex-col w-full">
        {label && (
          <label className="text-body font-medium text-content-primary mb-1.5">
            {label}
            {required && <span className="text-danger-500 ml-0.5">*</span>}
          </label>
        )}
        <select
          ref={ref}
          className={`
            w-full px-3 py-2.5 text-body text-content-primary
            bg-surface-card border rounded-input
            focus:outline-none focus:border-brand-500 focus:ring-1 focus:ring-brand-500/20
            transition-colors duration-150
            disabled:bg-surface-hover disabled:cursor-not-allowed
            ${error ? "border-danger-500" : "border-surface-border"}
            ${className}
          `.trim()}
          {...props}
        >
          {children}
        </select>
        {error && <p className="text-danger-500 text-caption mt-1">{error}</p>}
        {helperText && !error && (
          <p className="text-content-tertiary text-caption mt-1">{helperText}</p>
        )}
      </div>
    );
  }
);

Select.displayName = "Select";
export default Select;
